import Vue from 'vue'
import VueI18n from 'vue-i18n'
import moment from 'moment'
import 'moment/locale/es'
import 'moment/locale/pt-br'

import en from './locales/en'
import vuetify from '../plugins/vuetify'

// Customize Spanish locale to use shorter date format
moment.updateLocale('es', {
  longDateFormat: {
    ll: 'D MMM YYYY' // Changed from 'D [de] MMMM [de] YYYY'
  }
})

Vue.use(VueI18n)

// Map i18n locale codes to moment locale codes
var momentLocaleMap = {
  pt: 'pt-br'
}

/**
 * Lazy load a language file
 * @param {VueI18n} i18n - The VueI18n instance
 * @param {string} lang - The language code to load
 * @returns {Promise}
 */
export function loadLanguageAsync (i18n, lang) {
  var momentLang = momentLocaleMap[lang] || lang

  // Return immediately if language is already loaded
  if (i18n.availableLocales.includes(lang)) {
    i18n.locale = lang
    moment.locale(momentLang)
    vuetify.framework.lang.current = lang
    return Promise.resolve()
  }

  // Dynamically import the language file
  return import(/* webpackChunkName: "lang-[request]" */ './locales/' + lang + '.js')
    .then(function (messages) {
      i18n.setLocaleMessage(lang, messages.default)
      i18n.locale = lang
      moment.locale(momentLang)
      vuetify.framework.lang.current = lang
      return Promise.resolve()
    })
}

// Create and export the i18n instance
var i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  silentTranslationWarn: process.env.NODE_ENV === 'production',
  silentFallbackWarn: true,
  messages: {
    en: en
  }
})

export default i18n
